import { render, staticRenderFns } from "./ExternalCreateTicket.vue?vue&type=template&id=3196ff3e&"
import script from "./ExternalCreateTicket.vue?vue&type=script&lang=js&"
export * from "./ExternalCreateTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports